import { ErrorResponseJSONInterface } from '../interfaces/ErrorResponseJSONInterface';

export class FetchError {
  constructor(
    public message: string,
    public statusCode?: number,
    public response?: ErrorResponseJSONInterface,
  ) {}
}
